exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skin-card img[data-v-6168cf71]{-o-object-fit:cover;object-fit:cover;-o-object-position:75% 0;object-position:75% 0}", ""]);

// exports
